import { getSimulationItems } from '../Gui/store/persistent/persistentStore';
import { getSentence } from '../Gui/constants/sentences';
import { MIXED, SIM_NOISE, SIM_SUN, SIM_SUN4D, SIM_TARGET, SIM_VVA, SIM_WIND } from '@visualizer/types';

export const getSimConfig = (simKind: number) => {
    const linesColorMode = getSimulationItems().linesColorMode;
    switch (simKind) {
        case SIM_NOISE:
            return { raysHueRange: linesColorMode.Lines_NOISE_H, isMultiLine: true };
        case SIM_WIND:
            return { raysHueRange: linesColorMode.Lines_WIND_H, isMultiLine: true };
        case SIM_SUN:
        case SIM_SUN4D:
            return { raysHueRange: linesColorMode.Lines_SUN_H, isMultiLine: false };
        case SIM_VVA:
            return { raysHueRange: linesColorMode.Lines_VIEW_H, isMultiLine: false };
        case SIM_TARGET:
            return { raysHueRange: linesColorMode.Lines_VIEW_H, isMultiLine: false };
        default:
            throw new Error('This simKind do not exist');
    }
};

export const getSimTooltip = (simKind: number, frameCount: number) => {
    switch (simKind) {
        case SIM_NOISE:
            return getSentence('Data.Treeview.Noise.tooltip');
        case SIM_WIND:
            return getSentence('Data.Treeview.Wind.tooltip');
        case SIM_SUN:
            return getSentence('Data.Treeview.YearlySun.tooltip');
        case SIM_SUN4D:
            if (frameCount == 24) return getSentence('Data.Treeview.HourlySun.tooltip');
            else return getSentence('Data.Treeview.MonthlySun.tooltip');
        case SIM_VVA:
            return getSentence('Data.Treeview.FreeView.tooltip');
        case SIM_TARGET:
            return getSentence('Data.Treeview.TargetView.tooltip');
        default:
            return undefined;
    }
};

export const getDefaultVectorialScalarMode = (simKind: number): 0 | 1 => {
    switch (simKind) {
        case SIM_VVA:
            return 1; // FreeView -> Scalar
        case SIM_WIND:
        case SIM_NOISE:
        case SIM_SUN:
        case SIM_SUN4D:
        case SIM_TARGET:
        case MIXED:
        default:
            return 0; // Module
    }
};

export const isVectorialScalarModeToggleEnabled = (simKind: number): boolean => {
    return simKind !== SIM_WIND && simKind !== SIM_NOISE;
};
